export default __webpack_public_path__ + "static/Inter-Regular-6fcad65b7a8f7ffabb8e061a8be9d59e.woff2";